import { Clock, CloseCircle, Edit2, Send2 } from "iconsax-react";
import CheckIcon from "@/shared/assets/icons/CheckIcon";

export const STATUS_MAP = {
  draft: {
    label: "status.draft",
    color: "info",
    icon: <Send2 size={14} color="currentColor" />,
  },
  submitted: {
    label: "status.submitted",
    color: "notice",
    icon: <Clock size={14} color="currentColor" variant="Bold" />,
  },
  revision_requested: {
    label: "status.revision_requested",
    color: "notice",
    icon: <Edit2 size={14} color="currentColor" />,
  },
  approved: {
    label: "status.approved",
    color: "positive",
    icon: <CheckIcon />,
  },
  rejected: {
    label: "status.rejected",
    color: "negative",
    icon: <CloseCircle size={14} color="currentColor" variant="Bold" />,
  },
  active: {
    label: "status.active",
    color: "positive",
    icon: <CheckIcon />,
  },
} as const;

